<template>
    <div>
        <b-tabs v-model="tabIndex" small content-class="mt-3">
            <b-tab title="VENCIMENTO E VALORES" active>
                <OrdemServico ref="form" :tarefa_id="tarefa_id" :financeiro_id="financeiro_id" @setForm="setForm">
                </OrdemServico>
            </b-tab>
            <b-tab title="RESUMO" lazy>
                <ResumoForm ref="resumo" :servico="form" v-if="form" :cliente_id="cliente_id"></ResumoForm>
            </b-tab>
        </b-tabs>
        <div class="text-center">
            <b-button-group class="mt-2">
                <b-button @click="tabIndex--" v-if="tabIndex == 1">Voltar</b-button>
                <b-button variant="primary" v-if="tabIndex == 1" @click="gerarBoleto()">Gerar Boleto</b-button>
                <b-button  @click="next()" v-if="tabIndex == 0">Avançar</b-button>
            </b-button-group>
        </div>
    </div>
</template>
<script>
import OrdemServico from './OrdemServico.vue'
import ResumoForm from './ResumoForm.vue'
export default {
    components: { OrdemServico, ResumoForm },
    data() {
        return {
            tabIndex: 0,
            servico: {},
            form: null,
        }
    },
    props: {
        cliente_id: Number,
        tarefa_id: Number,
        financeiro_id: Number,
    },
    methods: {
        setForm(form) {
            this.form = form;
            this.tabIndex++
        },
        next(){
            this.$refs.form.submit();

        },
        gerarBoleto(){
            this.$bvModal.show("ConfirmarEmail");
        }
    }
}
</script>
